export default {
  setLoading(state, loading) {
    state.loading = loading;
  },
  setDateRange(state, dateRange) {
    state.dateRange = dateRange;
  },
  setHasGeneratedReport(state, hasGeneratedReport) {
    state.hasGeneratedReport = hasGeneratedReport;
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-analytic/features/reports/pages/total-quote/store/mutations.js